import { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";

const ApprovedDropdown = ({ value, onChange, options }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value);
  const ref = useRef();

  useEffect(() => {
    // Close dropdown on outside click
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelected(option.value);
    onChange(option.value);
    setOpen(false);
  };

  return (
    <div
      className="approved-dropdown-wrapper"
      ref={ref}
      style={{ position: "relative", width: "120px" }}
    >
      <div
        className="approved-dropdown-selected"
        onClick={() => setOpen(!open)}
        style={{
          border: `1.5px solid ${selected === "blocked" ? "#c62828" : "#1a73e8"}`,
          borderRadius: "8px",
          padding: "8px 14px",
          fontSize: "14px",
          fontWeight: 500,
          cursor: "pointer",
          color: selected === "blocked" ? "#c62828" : "#1a73e8",
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {options.find((o) => o.value === selected)?.label || "Select"}
        <FiChevronDown />
      </div>

      {open && (
        <div
          className="approved-dropdown-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: `1.5px solid ${selected === "blocked" ? "#c62828" : "#1a73e8"}`,
            borderRadius: "8px",
            marginTop: "4px",
            zIndex: 10,
            maxHeight: "150px",
            overflowY: "auto",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          {/* {options.map((option) => (
            <div
              key={option.value}
              onClick={() => handleSelect(option)}
              style={{
                padding: "8px 14px",
                cursor: "pointer",
                backgroundColor: option.value === selected ? "#ffeaea" : "#fff",
                zIndex:"99"
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#ffeaea")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor =
                  option.value === selected ? "#ffeaea" : "#fff")
              }
            >
              {option.label}
            </div>
          ))} */}
          {options.map((option) => {
            const isSelected = option.value === selected;
            const isBlocked = option.value === "blocked";

            return (
              <div
                key={option.value}
                onClick={() => handleSelect(option)}
                style={{
                  padding: "8px 14px",
                  cursor: "pointer",
                  zIndex: "999",
                  backgroundColor: isSelected
                    ? isBlocked
                      ? "#ffeaea"
                      : "#e8f0fe"
                    : "#fff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = isBlocked
                    ? "#ffeaea"
                    : "#e8f0fe";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = isSelected
                    ? isBlocked
                      ? "#ffeaea"
                      : "#e8f0fe"
                    : "#fff";
                }}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ApprovedDropdown;
